import script from "./Loading.vue?vue&type=script&setup=true&lang=js"
export * from "./Loading.vue?vue&type=script&setup=true&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=81c89b92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81c89b92"]])

export default __exports__